var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"pl-12 pr-12 pt-12 pb-12"},_vm._l((_vm.products),function(product,index){return _c('b-col',{key:index,attrs:{"cols":"12"}},[_c('ProductCard',{attrs:{"product":product,"transaction-id":_vm.transaction.id}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }